// ==================================================================================== INSTAGRAM EMBED
var cobaltfeed = new Instafeed({
  accessToken: InstagramToken,
  limit: 8,
  templateBoundaries: ['<%','%>'],
  template: '<div class="co-home-section-7-insta-div z-div"><a class="co-home-section-7-insta-a z-a" href="<% link %>" target="_blank"><img class="lazyload co-home-section-7-insta-img z-img-absolute" title="<% caption %>" src="<% image %>"/></a></div>',
  after: function() {
    var elem = document.querySelector('#instafeed');
    var flkty = new Flickity( elem, {
      cellAlign: 'left',
      autoPlay: true,
      contain: true,
      pageDots: false, 
      wrapAround: true, 
      prevNextButtons: false
    });
  }
});
cobaltfeed.run();  